import state from './moduleFiltersState.js'
import mutations from './moduleFiltersMutations.js'
import actions from './moduleFiltersActions.js'
import getters from './moduleFiltersGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
